
import sidbakery from '../assets/sidbakery.png';
import head from '../assets/head.png';
import cookie3 from '../assets/cookie3.png';
import cookie5 from '../assets/cookie5.jpg';
import veg from '../assets/VEG.png';
import nonveg from '../assets/nonveg.png';
import chefimg from '../assets/chef.jpg';
import location from '../assets/location3.png';
import menu1 from '../assets/menu1.jpg';
import menu2 from '../assets/menu2.jpg';
import menu3 from '../assets/menu3.jpg';
import menu4 from '../assets/menu4.jpg';
import menu5 from '../assets/menu5.jpg';
//  eslint-disable-next-line 
export default {
  nonveg,
  veg,
  sidbakery,
  head,
  cookie3,
  cookie5,
  chefimg,
  location,
  menu1,
  menu2,
  menu3,
  menu4,
  menu5,
};
